import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';
import { useParams, useSearchParams } from 'react-router-dom';

export default function Dashboard() {
  const { alias: aliasParam } = useParams();
  const [searchParams] = useSearchParams();
  const alias = aliasParam || searchParams.get('alias') || null;
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

useEffect(() => {
  const fetchTopics = async () => {
    setLoading(true);
    try {
      let courseName = 'FRM-2'; // fallback

      // if alias param exists in URL, look up the actual course name
      if (alias) {
        const { data: courseRow, error: courseError } = await supabase
          .from('courses')
          .select('name')
          .eq('alias', alias)
          .maybeSingle();

        if (courseError) {
          console.error('Error fetching course:', courseError);
          setTopics([]);
          setLoading(false);
          return;
        }

        if (courseRow) {
          courseName = courseRow.name;
          
        }
      }

      const { data, error } = await supabase
        .from('main_topic_summary')
        .select('*')
        .eq('course', courseName);

      if (error) {
        console.error('Error fetching topics:', error);
        setTopics([]);
      } else {
        setTopics(data);
      }
    } catch (err) {
      console.error('Unexpected error:', err);
      setTopics([]);
    } finally {
      setLoading(false);
    }
  };

  fetchTopics();
}, [alias]);


  if (loading) return <div className="p-4">Loading...</div>;

  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
        <h2 className="text-3xl font-bold mb-10 text-center text-indigo-700 tracking-wide">
          📚 Topics Overview <span className="text-sm text-indigo-400"></span>
        </h2>
      {topics.length === 0 ? (
        <div className="text-gray-500">No topics available.</div>
      ) : (
        <table className="min-w-full bg-white shadow rounded overflow-hidden">
          <thead className="bg-indigo-600 text-white text-left text-sm uppercase tracking-wider">
            <tr>
              <th className="px-4 py-3">📘 Area</th>
              <th className="px-4 py-3">🧩 Subtopic Count</th>
              <th className="px-4 py-3">📄 Outline Count</th>
              <th className="px-4 py-3">🎯 Course</th>
            </tr>
          </thead>
          <tbody>
            {topics.map((topic, index) => (
              <tr
                key={index}
                className="hover:bg-indigo-50 cursor-pointer transition-all"
                onClick={() => navigate(`/topics/${topic.main_id}`)}
              >
                <td className="px-4 py-3 text-indigo-700 font-semibold">{topic.main_topic}</td>
                <td className="px-4 py-3">{topic.subtopics}</td>
                <td className="px-4 py-3">{topic.outlines}</td>
                <td className="px-4 py-3 text-sm text-gray-600">{topic.course}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
